let header_menu_desktop = document.querySelector('.header-menu-desktop');

const toggleSideMenu = () => {
    const menu_mobile = document.querySelector(`#main-mobile-menu`)
    menu_mobile.classList.toggle("open");
    if(menu_mobile.classList.contains("open")) {
        document.body.style.overflow= "hidden";
    } else {
        document.body.style.overflow= "auto";

        const submenues= document.querySelectorAll('.menu-mobile');
        submenues.forEach(element => {
            element.classList.remove("open");
        });
    }
}

const backSideMenu = (id) => {
    const menu_mobile = document.querySelector(`#${id}`)
    menu_mobile.classList.toggle("open");
}

const nextSideMenu = (id) => {
    const menu_mobile = document.querySelector(`#${id}`)
    menu_mobile.classList.toggle("open");
}

// Add event listeners to the menu items
const menuItems = document.querySelectorAll('.menu-item');
menuItems.forEach(item => {
    item.addEventListener('mouseover', (e) => {
        showDesktopMenu(e.target.dataset.id);
    });
    item.addEventListener('mouseleave', (e) => {
        const rect = header_menu_desktop.getBoundingClientRect();
        if (e.clientY < rect.top || e.clientX < rect.left || e.clientX > rect.right) {
            hideDesktopMenu();
        }
    });
});

const bigMenus = document.querySelectorAll('.menu-desktop');
bigMenus.forEach(element => {
    element.addEventListener('mouseleave', (e) => {
        hideDesktopMenu();
    });
});


const hideDesktopMenu = () => {
    const menus_desktop = document.querySelectorAll(`.menu-desktop`)
    menus_desktop.forEach(element => {
        element.classList.remove("open");
    });
}

const hideThisDesktopMenu = (id) => {
    const menu_desktop = document.querySelector(`#menu-${id}`)

    menu_desktop.classList.remove("open");
}

const showDesktopMenu = (id) => {
    if (id === undefined) {
        return;
    };
    hideDesktopMenu();

    const menu_desktop = document.querySelector(`#menu-${id}`)

    menu_desktop.classList.add("open");

}